import styled from 'styled-components';
import CheckboxField, { type CheckboxFieldProps } from '../../../components/fields/CheckboxField';
import { CheckboxCss } from '../Checkbox';

const StyledCheckboxField = styled(CheckboxField)`
    ${CheckboxCss}
`;

type CheckboxInputFieldProps = CheckboxFieldProps;

const CheckboxInputField = (props: CheckboxInputFieldProps) => <StyledCheckboxField {...props} />;

export default CheckboxInputField;
